import {useAppSelector} from "../../../../../../../redux/hooks";
import {
  isMySongsPageSelectedSongDetailsLoadedWithoutLessons
} from "../../../../../modules/my-songs-page-store/mySongsPage.selectors";

export interface IWhenSongDetailsLoadedWithoutLessonsLogic {
  isConditionPassed: boolean;
}

export const useWhenSongDetailsLoadedWithoutLessonsLogic = (): IWhenSongDetailsLoadedWithoutLessonsLogic => {
  const isConditionPassed = useAppSelector(isMySongsPageSelectedSongDetailsLoadedWithoutLessons);
  return {
    isConditionPassed,
  };
}
